import React from 'react';
import ManagementSectionManager, {
  type ManagerFieldDef,
  type ManagerColumnDef,
} from '@/components/ManagementSectionManager';

/**
 * Testimonials manager (management websites only).
 */

const fields: ManagerFieldDef[] = [
  { name: 'quote', label: 'Quote', type: 'textarea', required: true, maxLength: 2000, rows: 4 },
  { name: 'authorName', label: 'Author Name', type: 'text', required: true, maxLength: 120 },
  { name: 'authorRole', label: 'Role / Title', type: 'text', maxLength: 120 },
  { name: 'company', label: 'Company', type: 'text', maxLength: 120 },
  {
    name: 'imageUrl',
    label: 'Author Photo',
    type: 'image',
    aspectRatio: 1,
    circular: true,
    helpText: 'Square crop — shown in a circle next to the quote.',
  },
];

const columns: ManagerColumnDef[] = [
  {
    name: 'authorName',
    label: 'Author',
    render: (item) => (
      <div className="flex items-center gap-3">
        {item.imageUrl ? (
          // eslint-disable-next-line @next/next/no-img-element
          <img src={item.imageUrl} alt="" className="w-9 h-9 rounded-full object-cover shrink-0" />
        ) : (
          <div className="w-9 h-9 rounded-full bg-muted shrink-0" />
        )}
        <span>
          <span className="font-medium block">{item.authorName}</span>
          {(item.authorRole || item.company) && (
            <span className="text-muted-foreground text-xs">
              {[item.authorRole, item.company].filter(Boolean).join(' · ')}
            </span>
          )}
        </span>
      </div>
    ),
  },
  {
    name: 'quote',
    label: 'Quote',
    render: (item) => (
      <span className="text-muted-foreground">
        {item.quote?.length > 80 ? `${item.quote.slice(0, 80)}…` : item.quote}
      </span>
    ),
  },
];

const TestimonialsManager: React.FC = () => (
  <ManagementSectionManager
    title="Testimonials"
    description=""
    apiPath="/api/testimonials"
    sectionKey="testimonials"
    itemLabel="testimonial"
    fields={fields}
    columns={columns}
    toggleField={{ name: 'isActive' }}
    emptyHint="No testimonials yet. Add your first quote to build trust on your website."
  />
);

export default TestimonialsManager;
